import { render } from "./InputRut.vue?vue&type=template&id=07b394cc&scoped=true"
import script from "./InputRut.vue?vue&type=script&lang=js"
export * from "./InputRut.vue?vue&type=script&lang=js"

import "./InputRut.vue?vue&type=style&index=0&id=07b394cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b394cc"]])

export default __exports__